import type { OperationalSource } from "@/types/api";

/** Whole-day delta from planned → current (positive = later). */
export function dayDelta(
  current: string | null | undefined,
  planned: string | null | undefined,
): number | null {
  if (!current || !planned) return null;
  const c = new Date(current);
  const p = new Date(planned);
  if (Number.isNaN(c.getTime()) || Number.isNaN(p.getTime())) return null;
  return Math.round((c.getTime() - p.getTime()) / 86_400_000);
}

export function formatDayShift(delta: number): string {
  if (delta === 0) return "unchanged";
  const days = Math.abs(delta);
  const unit = days === 1 ? "day" : "days";
  return delta > 0 ? `+${days} ${unit}` : `−${days} ${unit}`;
}

export function operationalSourceLabel(
  source: OperationalSource | null | undefined,
): string | undefined {
  switch (source) {
    case "agent":
      return "Agent update";
    case "carrier_tracking":
      return "Carrier tracking";
    case "schedule":
      return "Schedule match";
    default:
      return undefined;
  }
}

export function operationalSourceDescription(
  source: OperationalSource | null | undefined,
): string | undefined {
  switch (source) {
    case "agent":
      return "The latest date from the handling agent's booking update.";
    case "carrier_tracking":
      return "Confirmed by the carrier's container tracking feed.";
    case "schedule":
      return "Matched from published carrier sailing schedules.";
    default:
      return undefined;
  }
}
